import React from 'react';
import { CommonEmbed } from 'components/common/CommonEmbed';

export const InquiryList: React.FC = () => {
    return <CommonEmbed title="문의 내역" path="/qna" />;
};
